'use cluent';

import classNames from 'classnames';
import { useField, ErrorMessage } from 'formik';
import TextareaAutosize from 'react-textarea-autosize';
import { IFormFieldTextareaProps } from 'app/interfaces/forms';
import FormFieldError from 'app/components/common/FormFieldError';

export default function FormFieldTextarea({
  name,
  placeholder,
  rows,
  autosize = true,
  className
}: IFormFieldTextareaProps) {
  const [field, meta, helpers] = useField({ name });

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let currentValue = e.target.value.trimStart();
    helpers.setValue(currentValue);
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex-grow">
        {autosize ? (
          <TextareaAutosize
            {...field}
            minRows={rows}
            placeholder={placeholder}
            onChange={handleChange}
            className={classNames('input-textarea', className, {
              'has-value': !!field.value
            })}
          ></TextareaAutosize>
        ) : (
          <textarea
            {...field}
            rows={rows}
            placeholder={placeholder}
            onChange={handleChange}
            className={classNames('input-textarea', className, {
              'has-value': !!field.value
            })}
          ></textarea>
        )}
      </div>
      <ErrorMessage
        component={() => <FormFieldError message={meta.error} />}
        name={name}
      />
    </div>
  );
}
